
export default class ImageTicker {
	constructor(el) {

		this.showCaption 	= this.showCaption.bind(this)
		this.hideCaption 	= this.hideCaption.bind(this)
		this.images 		= [...el.querySelectorAll('.image-ticker__image')]
		this.captions		= [...el.querySelectorAll('.image-ticker__caption')]

		this.images.forEach(image => {
			image.addEventListener('mouseover', this.showCaption)
			image.addEventListener('mouseout', this.hideCaption)
		});

	}

	showCaption(e) {
		const index = this.images.indexOf(e.currentTarget)
		this.captions.forEach(caption => {
			caption.classList.remove('image-ticker__caption--active')
		});
		this.captions[index].classList.add('image-ticker__caption--active')
	}

	hideCaption(e) {
		const index = this.images.indexOf(e.currentTarget)
		this.captions[index].classList.remove('image-ticker__caption--active')
	}
  
}
